export enum UserTypeEnum {
  COMPANY_SELLER = 1,
  COMPANY_BUYER = 2,
  ADMIN = 0,
}

export const UserTypeToLabel: {
  [key in UserTypeEnum]: string;
} = {
  [UserTypeEnum.COMPANY_SELLER]: "売り手",
  [UserTypeEnum.COMPANY_BUYER]: "買い手",
  [UserTypeEnum.ADMIN]: "管理者",
};
